import { Flex, Typography } from '@aloft/toolkit-sui';

import { ValuationTablePropertyHeaderProps } from './types.js';

export const ValuationTablePropertyHeaderSecondLine = ({
  subtitle,
  subtitle2,
}: ValuationTablePropertyHeaderProps) => (
  <Flex flexDirection="column" width="100%" lineHeight="1.3">
    <Typography variant="subtitle3" truncate color="textTertiary">
      {subtitle ?? ''}
    </Typography>
    <Typography variant="subtitle3" truncate color="textTertiary">
      {subtitle2 ?? ''}
    </Typography>
  </Flex>
);
